import React, { useCallback, useState } from 'react';

import api from '../api';
import { Provider as name } from '../config';
import { useGet, useGetById, usePost, usePut, useRemove, useSoftDelete } from '../../apiHooks';
import { Hotel } from '../types';
import { ModelOptions } from '../../../types';
import { HotelQueryType } from '../helpers';

import Context from './context';

interface Props {
    children: React.ReactNode;
}

function HotelsProvider({ children }: Props) {
    const [data, setData] = useState<Array<Hotel>>([]);
    const [selected, setSelected] = useState<Hotel | {}>({});
    const [error, setError] = useState({});

    const getById = useGetById(api, selected, setSelected, setError);

    const handleGetData = useCallback((res) => {
        setData(res);
        return res;
    }, []);
    const get = useGet(api, data, handleGetData, setError);

    // const getSchema = useGetSchema(api, schema, setSchema, setError);
    const handleSetData = useCallback((item, newData) => {
        setData(newData);
    }, []);
    const post = usePost(api, data, handleSetData, setError);

    const put = usePut(api, data, handleSetData, setError);

    const handleDeleteCallback = useCallback((id, newData) => {
        setData(newData);
        setSelected({});
        return id;
    }, []);
    const remove = useRemove(api, data, handleDeleteCallback, setError);

    const softDelete = useSoftDelete(api, data, handleDeleteCallback, setError);

    const query = useCallback(async (query: HotelQueryType, options?: ModelOptions) => {
        try {
            const res = await api.query(query, options);
            return res;
        } catch (err) {
            setError(err);
            throw err;
        }
    }, []);

    return (
        <Context.Provider
            value={{
                name,
                get,
                getById,
                // getSchema,
                schema: undefined,
                post,
                put,
                data,
                setData,
                selected,
                setSelected,
                remove,
                error,
                softDelete,
                query
            }}
        >
            {children}
        </Context.Provider>
    );
}

export default HotelsProvider;
